import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-20">
      <div className="text-center max-w-md">
        <div className="text-8xl md:text-9xl font-extrabold bg-gradient-to-br from-cyan-600 to-teal-600 bg-clip-text text-transparent mb-4">404</div>
        <h1 className="text-3xl font-bold text-slate-900 mb-3">Página no encontrada</h1>
        <p className="text-slate-600 mb-8">La página que buscas no existe o ha sido movida.</p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-cyan-600 to-teal-600 text-white font-semibold shadow-md hover:scale-105 transition">
            <Home size={18} /> Ir al inicio
          </Link>
          <button onClick={() => window.history.back()} className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-slate-200 text-slate-700 font-semibold hover:border-cyan-600 transition">
            <ArrowLeft size={18} /> Volver atrás
          </button>
        </div>
      </div>
    </div>
  );
}
